
namespace GeniuzPOS.RefundReasonReport {

    @Serenity.Decorators.registerClass()
    export class ReportRefundReasonSumBillDtDialog extends Serenity.Extensions.GridEditorDialog<ReportRefundReasonSumBillDtRow> {
        protected getFormKey() { return ReportRefundReasonSumBillDtForm.formKey; }
        // protected getIdProperty() { return ReportRefundReasonSumBillDtRow.idProperty; }
        protected getLocalTextPrefix() { return ReportRefundReasonSumBillDtRow.localTextPrefix; }
        protected getNameProperty() { return ReportRefundReasonSumBillDtRow.nameProperty; }
        // protected getService() { return ReportRefundReasonSumBillDtService.baseUrl; }
        // protected getDeletePermission() { return ReportRefundReasonSumBillDtRow.deletePermission; }
        // protected getInsertPermission() { return ReportRefundReasonSumBillDtRow.insertPermission; }
        // protected getUpdatePermission() { return ReportRefundReasonSumBillDtRow.updatePermission; }

        protected form = new ReportRefundReasonSumBillDtForm(this.idPrefix);

         protected getToolbarButtons(): Serenity.ToolButton[] {

            let buttons = super.getToolbarButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
               buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            return buttons;


        }



    }
}